<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE8B4;</i>
          <span>Manage Testing Centers</span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p><span>Search Locations</span></p>
              </div>
            </md-card-title>
            <md-card-content>
              <form class="example-form" [formGroup]="form">
                <div class="col s12 m4 l4" *ngIf="showField">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Region" mdInput formControlName="regionControl" [mdAutocomplete]="region" [showDropDown]="{model: 'region', scope : this }">
                    <md-autocomplete #region="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of regionFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                </div>
                <div class="col s12 m4 l4">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Country" mdInput formControlName="countryControl" [mdAutocomplete]="country" [showDropDown]="{model: 'country', scope : this }">
                    <md-autocomplete #country="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                </div>
                <div class="col s12 m4 l4">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Location Name" mdInput formControlName="locationControl" [mdAutocomplete]="location" [showDropDown]="{model: 'location', scope : this }">
                    <md-autocomplete #location="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of locationFilteredOptions | async" [value]="option" class="subOptionShow">
                        <span>
                          {{ option.name }}
                          <span title="{{ option.locationAddress }}" class="locationListAddressCls">
                            <br/>{{ option.locationAddress }}</span>
                        </span>
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                </div>
                <div class="col s12 m4 l4">
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Keyboard Type" mdInput formControlName="keyboardTypeControl" [mdAutocomplete]="keyboard"
                      [showDropDown]="{model: 'keyboardType', scope : this }">
                    <md-autocomplete #keyboard="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of keyboardTypeFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                </div>
              </form>
              <div class="col s12 m12 l12">
                <div class="button-row">
                  <button [disabled]="isSearchDisable" md-raised-button class="glbAdminBtnCls1" (click)="onSearchBtnClick()">
                    <i class="material-icons">&#xE8B6;</i>Search</button>
                  <button md-raised-button class="glbAdminBtnCls1" [routerLink]="['/AdmManageLocation', 0]" (click)="_appGlobal.routeWithID = true">
                    <i class="material-icons">&#xE145;</i>Add Location</button>
                </div>
              </div>
            </md-card-content>
          </div>
        </md-card-header>
      </md-card>
      <div class="cusPaginationContainer example-container mat-elevation-z8">
        <div *ngIf="paginationInfo && paginationInfo.totalRecords == 0">
          <p class="nodataFound">No Results Found</p>
        </div>
        <md-table class="mngLocGridSec" #table [dataSource]="dataSource" mdSort [ngClass]="{'hide-grid': paginationInfo &&paginationInfo.totalRecords == 0 }">
          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>
          <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
          <ng-container mdColumnDef="code">
            <md-header-cell *mdHeaderCellDef md-sort-header>LOCATION NAME</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.code}}</md-cell>
          </ng-container>
          <ng-container mdColumnDef="locationAddress">
            <md-header-cell *mdHeaderCellDef md-sort-header>LOCATION ADDRESS</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.locationAddress}} </md-cell>
          </ng-container>
          <ng-container mdColumnDef="keyboardType">
            <md-header-cell *mdHeaderCellDef md-sort-header>KEYBOARD TYPE</md-header-cell>
            <md-cell *mdCellDef="let element">{{element.keyboardType}}</md-cell>
          </ng-container>
          <ng-container mdColumnDef="status">
            <md-header-cell *mdHeaderCellDef md-sort-header>STATUS</md-header-cell>
            <md-cell *mdCellDef="let element">
              <span [ngClass]="getStatusCls(element.status)"></span> {{element.status}} </md-cell>
          </ng-container>
          <ng-container mdColumnDef="action">
            <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
            <md-cell *mdCellDef="let element">
              <a [routerLink]="['/AdmManageLocation', element.id]" (click)="_appGlobal.routeWithID = true">Manage</a>
            </md-cell>
          </ng-container>
        </md-table>
        <md-paginator [ngClass]="{'hide-grid': paginationInfo && paginationInfo.totalRecords == 0 }" #paginator [length]="paginationInfo.totalRecords"
          [pageSize]="dataSource.initialPageSize" [pageSizeOptions]="dataSource.pageSizeOptions" (page)="dataSource.onPaginateChange(appUrl.searchLocationsByFilter,$event,this,remotePaginationParams)">
        </md-paginator>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-manage-location.component.html